import { Injectable } from '@angular/core';
import { UserSettingsValidation } from 'node_js/models/business/user-settings-validation';
import { User } from 'node_js/models/tables/user';
import { UserAuthService } from './user-auth.service';
import { HttpClient } from '@angular/common/http';
import { connLink } from 'src/global';
import { UserSettingsComplete } from 'node_js/models/business/user-settings-complete';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {

  minPasswordChars = 8;
  maxPasswordChars = 20;
  maxFirstNameChars = 45;
  maxLastNameChars = 45;
  maxDisplayNameChars = 100;

  constructor(private http:HttpClient) {
  }

  resetValidationErrors(validationErrors:UserSettingsValidation){
    validationErrors.confirmPassword = "";
    validationErrors.dob = "";
    validationErrors.email = "";
    validationErrors.firstName = "";
    validationErrors.lastName = "";
    validationErrors.displayName = "";
    validationErrors.password = "";
    validationErrors.phoneNumber = "";
    validationErrors.gender = "";
  }

  validateSignUp(validationErrors:UserSettingsValidation,user:User,confirmPassword:string){
    
    this.resetValidationErrors(validationErrors);


    let valid = true;
    
    //Email
    if (!this.validateEmail(user.email)){
      valid = false;
      validationErrors.email = "Must be valid email";
    }
    else if (user.email.length > 320){
      valid = false;
      validationErrors.email = "Email is too long";
    }
   

    //Password
    if (user.password.length < 8 && user.password.length < 20){
      valid = false;
      validationErrors.password = "Password must be between 8 and 20 characters";
    }
    

    //Confirm Password
    if (user.password != confirmPassword){
      valid = false;
      validationErrors.confirmPassword = "Passwords must match";
    }

    //First Name
    if (user.firstName.length == 0){
      valid = false;
      validationErrors.firstName = " ";
    }
    else if (user.firstName.length > this.maxFirstNameChars){
      valid = false;
      validationErrors.firstName = "Must be less than " + this.maxFirstNameChars + " characters";
    }
   
    //Last Name
    if (user.lastName.length == 0){
      valid = false;
      validationErrors.lastName = " ";
    }
    else if (user.lastName.length > this.maxLastNameChars){
      valid = false;
      validationErrors.lastName = "Must be less than " + this.maxLastNameChars + " characters";
    }

    //Display Name
    if (user.displayName.length == 0){
      valid = false;
      validationErrors.displayName = " ";
    }
    else if (user.displayName.length > this.maxDisplayNameChars){
      valid = false;
      validationErrors.displayName = "Must be less than " + this.maxDisplayNameChars + " characters";
    }

    

    return valid;
  }


  validateEmail(email:string) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  validatePhoneNumber(phoneNumber:string) {
    var a = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/.test(phoneNumber);
    return a;
  }

  updateUserInformation(userSettingsComplete:UserSettingsComplete,userAuthService:UserAuthService){
    return new Promise<UserSettingsComplete>(async (resolve,reject)=>{
          let idToken = await userAuthService.createIdToken();
          this.http.post(connLink + "/updateUserInformation", { uid:userAuthService.currentUserComplete.user.authUid,idToken,userSettingsComplete }).subscribe(
              (response:any) => {
                  
                  console.log(response);
                  resolve(response);
              },
              (response:any) => {
               
                  reject();
              }
          )
        })
  }

}
